// extracted by mini-css-extract-plugin
export default {"mainsection":"SinglePage_mainsection__xre77","addcart":"SinglePage_addcart__YW+mX","aboutproduct":"SinglePage_aboutproduct__GfXv5"};